import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Grid,
  Box,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { ReactElement } from "react";
import CloseIcon from "@mui/icons-material/Close";

export interface AppDialogProps {
  open: boolean;
  title: any;
  content?: string;
  actions?: React.ReactNode;
  onCloseHandler?: () => void;
  children: any;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  id: string;
  popupIcon?: ReactElement<any, any>;
  hasCloseButton?: boolean;
}

export const AppDialog: React.FunctionComponent<AppDialogProps> = ({
  open,
  onCloseHandler,
  title,
  content,
  actions,
  children,
  maxWidth,
  id,
  popupIcon,
  hasCloseButton = true,
}) => {
  const styles = useStyles();
  return (
    <Dialog
      id={id}
      open={open}
      onClose={onCloseHandler}
      maxWidth={maxWidth}
      aria-labelledby="alert-dialog-slide-title"
    >
      {title && (
        <DialogTitle id="alert-dialog-slide-title" className={styles.titleRoot}>
          <Box display="flex" flexDirection={"row"}>
            {popupIcon && <Box paddingRight={2}>{popupIcon}</Box>}
            <Grid container spacing={2} flexGrow={1}>
              <Grid size={{ xs: 11, md: 11 }}>{title}</Grid>
              {hasCloseButton && (
                <Grid size={{ xs: 1, md: 1 }}>
                  <IconButton size="small" aria-label="close" onClick={onCloseHandler}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Box>
        </DialogTitle>
      )}
      <DialogContent dividers className={styles.contentRoot}>
        {content && (
          <DialogContentText id="alert-dialog-slide-description">{content}</DialogContentText>
        )}
        {children}
      </DialogContent>
      {actions && <DialogActions className={styles.actionRoot}>{actions}</DialogActions>}
    </Dialog>
  );
};

const useStyles = makeStyles(() => ({
  titleRoot: {
    fontSize: "16px",
    "@media (max-width:600px)": {
      padding: "5px 15px",
      "& h2": {
        fontSize: "0.8rem",
      },
    },
  },
  contentRoot: {
    "@media (max-width:960px)": {
      padding: "8px 26px 8px 5px",
    },
  },
  actionRoot: {
    "@media (max-width:600px)": {
      padding: "2px",
    },
  },
}));
